var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGoogleAds(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 61,
    height: 61,
    viewBox: "0 0 61 61",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.431 19.2347C25.6782 18.6699 25.8949 18.091 26.2503 17.5784C27.3853 15.9414 28.9773 15.0714 30.9426 15.0792C33.0982 15.0875 34.8107 16.05 35.9103 17.9406C39.6244 24.3266 43.312 30.7279 47.0344 37.1091C48.1624 39.0426 48.3478 40.9936 47.2394 42.9565C45.0794 46.782 39.6426 46.7875 37.3853 42.9726C35.3602 39.5498 33.3796 36.101 31.3769 32.6649C31.2583 32.4615 31.1665 32.2393 30.9918 32.0716C30.6939 31.8639 30.6107 31.5123 30.4415 31.2237C28.9654 28.7052 27.4806 26.1916 26.0227 23.6627C25.2291 22.286 24.8903 20.8086 25.431 19.2347Z",
    fill: "#3C8AD8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.431 19.2346C25.4849 19.4372 25.3928 19.6236 25.3616 19.8156C25.1337 21.2156 25.4569 22.5006 26.1621 23.7096C27.7187 26.3782 29.274 29.0475 30.8277 31.7177C30.893 31.8296 30.9375 31.9534 30.9917 32.0716C29.9151 33.8915 28.8359 35.7103 27.7624 37.5321C26.9085 38.981 26.0617 40.434 25.21 41.8841C25.1574 41.9736 25.0885 42.0535 25.0271 42.1379C24.9082 41.9719 24.995 41.8094 25.0364 41.647C25.3423 40.4503 25.2956 39.2662 24.8125 38.1298C23.9729 36.1549 22.4387 35.0541 20.3281 34.7651C18.6464 34.5348 17.1821 35.0417 15.9247 36.1738C15.7443 36.3362 15.5752 36.54 15.3005 36.5616C17.055 33.5356 18.8063 30.5078 20.5647 27.4842C22.1054 24.8349 23.6535 22.1901 25.2004 19.5445C25.2651 19.4339 25.3003 19.2978 25.431 19.2346Z",
    fill: "#F9BB03"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.3006 36.5618C16.0158 35.9368 16.7292 35.3203 17.6397 34.9678C21.1213 33.6199 24.9811 36.0146 25.3052 39.7206C25.378 40.5531 25.2157 41.3424 25.0275 42.1373C23.071 46.6455 18.4099 46.4682 16.1089 44.613C13.966 42.8852 13.3615 39.8453 14.7344 37.4642C14.9117 37.1568 15.1113 36.8622 15.3006 36.5618Z",
    fill: "#34A752"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogleAds);
export default __webpack_public_path__ + "static/media/google-ads.8759f8fef013e996eca484f2e31af9eb.svg";
export { ForwardRef as ReactComponent };